






















































































































































































































































































import { Vue, Component, Mixins } from "vue-property-decorator";
import MyList from "@/mixins/list";
import SelectStadium from "@/components/selectstadium.vue";
import Pie from "@/views/statistics-analy/download/piedata.vue";
import Hour24 from "@/views/statistics-analy/download/hour24.vue";
import Trend from "@/views/statistics-analy/download/trend.vue";

@Component({
  components: {
    SelectStadium,
    Pie,
    Hour24,
    Trend
  }
})
export default class extends Mixins(MyList) {
  dispatchType = "wechatdown/getLogs";

  // 操作搜索栏的展开和折叠
  isFlag = false;

  columns: any[] = [
    {
      title: "编号",
      dataIndex: "id"
    },
    {
      title: "类型",
      scopedSlots: { customRender: "type" }
    },
    {
      title: "时间",
      dataIndex: "created_time"
    },
    {
      title: "场馆",
      dataIndex: "stadium_name"
    },
    // {
    //   title: 'openid',
    //   dataIndex: 'openid'
    // },
    {
      title: "用户名",
      dataIndex: "nickname"
    },
    {
      title: "头像",
      scopedSlots: { customRender: "headimgurl" }
    },
    // {
    //   title: '国别',
    //   dataIndex: 'country'
    // },
    // {
    //   title: '省份',
    //   dataIndex: 'province'
    // },
    {
      title: "城市",
      dataIndex: "city"
    },
    {
      title: "性别",
      scopedSlots: { customRender: "sex" }
    },
    {
      title: "手机号",
      dataIndex: "mobile"
    },
    {
      title: "ip",
      dataIndex: "ip"
    },
    // {
    //   title: '用户id',
    //   dataIndex: 'user_id'
    // },
    {
      title: "系统",
      dataIndex: "platform"
    },
    { title: "应用", scopedSlots: { customRender: "app" } },
    { title: "来源", scopedSlots: { customRender: "utm_source" } },
    { title: "关键字", scopedSlots: { customRender: "utm_term" } },
    {
      title: "操作",
      scopedSlots: { customRender: "action" }
    }
  ];

  mounted() {
    this.loadData();
  }
}
